import { inject, Provider } from '@angular/core';
import {
    ControlContainer,
    FormGroupDirective,
    FormGroupName,
} from '@angular/forms';

export const ControlContainerProvider: Provider = {
    provide: ControlContainer,
    useFactory: () => {
        const formGroup = inject(FormGroupDirective);
        const formGroupName = inject(FormGroupName, {
            optional: true,
        });
        return formGroupName ?? formGroup;
    },
};
